// Product List Navigation & Footer Arrows - Connect to carousel
function initProductListArrows() {
  // 1. Bottom navigation controls (arrows + dots)
  const allCarousels = document.querySelectorAll('.resource-list__carousel slideshow-component');
  allCarousels.forEach(function(carousel) {
    if (carousel.dataset.controlsInitialized) return;
    carousel.dataset.controlsInitialized = 'true';

    function updateNavArrowStates() {
      if (carousel.infinite) return;
      const currentIndex = carousel.current || 0;
      const slides = carousel.querySelectorAll('slideshow-slide');
      const maxIndex = Math.max(0, slides.length - 1);

      const previousBtns = carousel.querySelectorAll('.product-list__controls .slideshow-control--previous');
      const nextBtns = carousel.querySelectorAll('.product-list__controls .slideshow-control--next');

      previousBtns.forEach(function(btn) {
        btn.disabled = currentIndex === 0;
      });

      nextBtns.forEach(function(btn) {
        btn.disabled = currentIndex >= maxIndex;
      });
    }

    carousel.addEventListener('slideshow:select', updateNavArrowStates);
    updateNavArrowStates();
  });

  // 2. Footer arrows ([data-carousel-footer-arrows])
  const allFooterArrows = document.querySelectorAll('[data-carousel-footer-arrows]');
  allFooterArrows.forEach(function(footerArrows) {
    if (footerArrows.dataset.initialized) return;
    footerArrows.dataset.initialized = 'true';

    // Find the carousel in the same section
    const section = footerArrows.closest('.section-resource-list');
    if (!section) return;

    const carousel = section.querySelector('.resource-list__carousel slideshow-component');
    if (!carousel) return;

    // Handle arrow clicks - slideshow-arrow uses class names for action
    footerArrows.addEventListener('click', function(e) {
      const button = e.target.closest('.slideshow-control');
      if (!button) return;

      if (button.classList.contains('slideshow-control--previous')) {
        carousel.previous();
      } else if (button.classList.contains('slideshow-control--next')) {
        carousel.next();
      }
    });

    // Update disabled state of arrows based on carousel position
    function updateArrowStates() {
      const previousBtn = footerArrows.querySelector('.slideshow-control--previous');
      const nextBtn = footerArrows.querySelector('.slideshow-control--next');

      if (!carousel.infinite) {
        const currentIndex = carousel.current || 0;
        const slides = carousel.querySelectorAll('slideshow-slide');

        if (previousBtn) {
          previousBtn.disabled = currentIndex === 0;
        }

        if (nextBtn) {
          nextBtn.disabled = currentIndex >= slides.length - 1;
        }
      }
    }

    // Listen for carousel changes
    carousel.addEventListener('slideshow:select', updateArrowStates);

    // Initial state
    updateArrowStates();
  });
}

document.addEventListener('DOMContentLoaded', initProductListArrows);
document.addEventListener('shopify:section:load', initProductListArrows);